import React from "react";
import Select from "react-select";
import { CSVLink } from "react-csv/lib";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faUpload, faDownload } from "@fortawesome/free-solid-svg-icons";

import DeployTile from "components/Tiles/DeployTile";
import ScoreTile from "components/Tiles/Score/ScoreTile";

import SalesforceImg from "images/datasource-sf.png";
import OracleImg from "images/datasource-ora.png";
import SAPImg from "images/datasource-sap.png";
import HTMLImg from "images/html-icon.png";
import RestImg from "images/restful-icon.png";
import JavaImg from "images/java-icon.png";
import PythonImg from "images/python-icon.png";
import RCodeImg from "images/rcode-icon.png";

import styles from "./style.module.css";

import FineUploaderTraditional from "fine-uploader-wrappers";
import FileInput from "react-fine-uploader/file-input";

import { getAPIBaseURL } from "api/DatasetAPI";

import { getAPIToken } from "utils/request";

export default class Deploy extends React.PureComponent {
  constructor(props) {
    super(props);

    this.uploader = new FineUploaderTraditional({
      options: {
        chunking: {
          enabled: false
        },
        deleteFile: {
          enabled: false,
          endpoint: getAPIBaseURL() + "v1/job/" + props.id + "/scores"
        },
        request: {
          endpoint: getAPIBaseURL() + "v1/job/" + props.id + "/scores",
          customHeaders: {
            Authorization: "Bearer " + getAPIToken()
          },
          inputName: "file",
          filenameParam: "name",
          params: {
            model_name: props.modelId,
            account_id: props.accountId
          }
        },
        retry: {
          enableAuto: false
        },
        cors: {
          expected: true,
          sendCredentials: false
        }
      }
    });

    this.uploader.on("complete", (id, name, response) => {
      return props.handleComplete({
        ...response,
        fileName: name.replace(".csv", "") + "_scored.csv"
      });
    });
  }

  renderScore(score, index) {
    const { isDownloadLoading, handleDownload } = this.props;

    const fileLink =
      score && score.processed_url
        ? "https://s3.console.aws.amazon.com/s3/buckets/" + score.processed_url.slice(5) + "/"
        : undefined;

    return (
      <ScoreTile
        key={index}
        score={score}
        title={"Download Scored Dataset"}
        onClick={
          handleDownload
            ? () => handleDownload(score.id, score.model_name, fileLink)
            : fileLink
              ? () => window.open(fileLink)
              : undefined
        }
      />
    );
  }

  render() {
    const {
      id,
      model,
      label,
      match,
      handleBack,
      modelTile,
      csv,
      scores,
      error,
      handleRestfulDeploy,
      fetchAllDeployments,
      updateDeploy
    } = this.props;

    return (
      <div className={styles.deploy}>
        <div className={styles.modelHolder}>{modelTile}</div>
        {model && model.id !== "decision-tree" && (
          <div className={styles.deployContainer}>
            <div className={styles.topHolder}>
              <div className={styles.deployMessage}>{"Manually Score Dataset:"}</div>
              {error && <div className={styles.error}>{"Error: " + error}</div>}
            </div>
            <div className={styles.flexHold}>
              <DeployTile
                title={"Upload Scoring Dataset"}
                middle={<FontAwesomeIcon icon={faUpload} />}
                onClick={() => document.getElementsByClassName("react-fine-uploader-file-input")[0].click()}
                isActive={true}
              />
              <div className={styles.deployTiles}>
                {scores !== undefined && Object.keys(scores).map((sKey) => this.renderScore(scores[sKey], sKey))}
              </div>
            </div>
          </div>
        )}
        <a onClick={() => fetchAllDeployments(id)}>{"Fetch all Deployments (network request)"}</a>
        <div className={styles.deployContainer} style={{ paddingTop: "0px" }}>
          <div className={styles.deployMessage}>{"Deploy using one of the options below:"}</div>
          <div className={styles.deployTiles}>
            <DeployTile
              title={"Restful API"}
              image={RestImg}
              onClick={() => handleRestfulDeploy(id, model.id)}
              isActive
            />
            <DeployTile title={"AIble on Oracle"} image={OracleImg} />
            <DeployTile title={"AIble on Salesforce"} image={SalesforceImg} />
            <DeployTile title={"AIble on SAP"} image={SAPImg} />
            <DeployTile title={"HTML Snippet"} image={HTMLImg} />
            <DeployTile title={"Java Code"} image={JavaImg} />
            <DeployTile title={"Python Code"} image={PythonImg} />
            <DeployTile title={"R Code"} image={RCodeImg} />
          </div>
        </div>
        <div className={styles.hide}>
          <FileInput uploader={this.uploader} />
        </div>
      </div>
    );
  }
}
